import axios from "axios";
import { loadToken } from "../component/action/preferences";
import appConfig from "./../appconfig.json";

const api_file = axios.create({
  baseURL: appConfig.apiBaseUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data",
  },
});

api_file.interceptors.request.use(async (config) => {
  config.headers["token"] = (await loadToken()) || null;
  // Always send country id
  config.headers["country-id"] = 1;
  config.params = {
    ...config.params,
    locale: localStorage.getItem("language") ?? "en",
  };
  return config;
});

export default api_file;
